/* eslint-disable no-unused-expressions */
import { useMenuOpen } from 'lib/util/toggle-menu';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSearchDictionary } from '../../util';
import { classnames } from 'tailwindcss-classnames';
import { useConnector } from 'react-instantsearch-hooks-web';
import 'react-datepicker/dist/react-datepicker.css';
import MonthFacet from '../../Facets/NetworkResourceCenter/Announcement/MonthFacet';
import YearFacet from '../../Facets/NetworkResourceCenter/Announcement/YearFacet';
import AudienceFacet from '../../Facets/NetworkResourceCenter/Announcement/AudienceFacet';
import { SearchWrapperProps } from '../../SearchTypes';
import AnnouncementClearFacets from '../../Facets/NetworkResourceCenter/Announcement/AnnouncementClearFacets';
import Button from 'components/helpers/Button';
import connectStats from 'instantsearch.js/es/connectors/stats/connectStats';

import type {
  StatsConnectorParams,
  StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats';

export type UseStatsProps = StatsConnectorParams;

export interface IMyProps {
  filters: string[];
}

function useStats(props?: UseStatsProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats as any, props);
}

const SearchFacetsWrapper = ({ children }: SearchWrapperProps) => {
  return <div className={classnames('mb-4')}>{children}</div>;
};

const SearchFacetsWithSearch = (props: UseStatsProps) => {
  const { nbHits } = useStats(props);

  const dict = useSearchDictionary();
  const resultsCount = dict.resultsCountNoQuery.replace('@count', nbHits.toString());

  const { toggleMenu, isMenuOpen } = useMenuOpen();

  const menuClasses = classnames(
    'bg-black',
    'bg-opacity-30',
    'duration-300',
    'fixed',
    'h-full',
    'w-full',
    'top-0',
    'transition-transform',
    'transform',
    'left-[100%]',
    'lg:relative',
    'lg:bg-theme-bg',
    {
      '-translate-x-full': isMenuOpen,
      'translate-x-0': !isMenuOpen,
      'lg:left-0': !isMenuOpen,
    }
  );
  return (
    <SearchFacetsWrapper>
      <div className={classnames('block', 'lg:hidden')}>
        <Button
          variant="secondary"
          className={classnames('mb-6', 'w-full', 'z-20')}
          onClick={toggleMenu}
        >
          Filter & Sort
        </Button>
        <hr className={classnames('mb-6', 'border-gray-midGray')} />
        <AnnouncementClearFacets />
      </div>
      <div className={menuClasses}>
        <div
          className={classnames(
            'absolute',
            'border',
            'border-gray-midGray',
            'box-border',
            'overflow-scroll',
            'h-full',
            'min-w-[200px]',
            'max-w-2xl',
            'py-6',
            'px-4',
            'w-fit',
            'w-full',
            'top-0',
            'right-0',
            'bg-white',
            'lg:relative',
            'lg:rounded-xl',
            'lg:min-w-full',
            'lg:overflow-hidden',
            'z-20'
          )}
        >
          <div className={classnames('flex', 'flex-col', 'lg:hidden')}>
            <Button
              variant="link"
              className={classnames('mb-6', 'z-20', 'text-right')}
              onClick={toggleMenu}
            >
              <span className={classnames('text-black')}>Close filters ✕</span>
            </Button>
            <Button
              variant="primary"
              className={classnames('mb-6', 'z-20', 'block', 'lg:hidden')}
              onClick={toggleMenu}
            >
              {resultsCount}
            </Button>
            <hr className={classnames('mb-4', 'border-gray-midGray')} />
          </div>
          <div
            className={classnames(
              'w-full',
              'justify-between',
              'items-center',
              'hidden',
              'lg:block'
            )}
          >
            <AnnouncementClearFacets />
          </div>
          <div className={classnames('w-full', 'justify-between')}>
            <AudienceFacet />
            <hr className={classnames('mb-4', 'border-gray-midGray')} />
            <YearFacet />
            <hr className={classnames('mb-4', 'border-gray-midGray')} />
            <MonthFacet />
          </div>
        </div>
      </div>
    </SearchFacetsWrapper>
  );
};

const AnnouncementFacets = () => {
  const { sitecoreContext } = useSitecoreContext();
  const pageEditing = sitecoreContext.pageEditing === true;
  if (pageEditing) {
    return (
      <SearchFacetsWrapper>
        <div className={classnames('mb-6', 'flex', 'w-full', 'justify-between', 'items-center')}>
          <h3 className={classnames('text-blue-navy', 'heading-md')}>Search Facets</h3>
        </div>
      </SearchFacetsWrapper>
    );
  }
  return <SearchFacetsWithSearch />;
};

export default AnnouncementFacets;
